$(document).ready(function(){
  var size_array = [];
  var size_array_running = true;

  var all_step = $("#calculate_shape .steps .step");
  function cn(hash) {
    return (typeof hash === "undefined" || hash == null || hash.toString().trim() == "");
  }
  $("#calculate_shape .steps .imgs").hover(function(){
    $(this).find(".hover").stop().fadeIn();
  },
                                           function(){
    $(this).find(".hover").stop().fadeOut();
  });
  function progress_next(){
    var current =  $("#calculate_shape .steps .progress_bar .circle.active");;
    var next = current.next();
    if(!cn(next)){
      next.addClass("active");
      current.removeClass("active");
    }

  }
  function proggress_prev(){
    var current = $("#calculate_shape .steps .progress_bar .circle.active");;
    var prev = current.prev();
    if(!cn(prev)){
      prev.addClass("active");
      current.removeClass("active");
    }
  }

  $("#calculate_shape .steps .prev").click(function(){
    var prev_slide = $(this).attr("data-prev");
    all_step.hide();
    $(prev_slide).show();
    proggress_prev();
  });
  /* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

  /*
            * Sh - Shoulder
            * H  - Hip
            * B  - Bust
            * W  - Waist
            */

  /* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

  /*
            * Sh - Shoulder
            * H  - Hip
            * B  - Bust
            * W  - Waist
            */

  /* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

  /*
            * Sh - Shoulder
            * H  - Hip
            * B  - Bust
            * W  - Waist
            */

  function checkShoulderEqualHips() {
    if (size_array[0] == 0) {
      // B>H
      if (size_array[3] == 1) {
        // B>W
        if (size_array[2] == 0) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/hourglass";
              break;
          }
        }

        // B=W
        if (size_array[2] == 1) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/hourglass";
              break;
          }
        }

        // B<W
        if (size_array[2] == 2) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }
      }

      // B=H
      if (size_array[3] == 0) {
        // B>W
        if (size_array[2] == 0) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/hourglass";
              break;
          }
        }

        // B=W
        if (size_array[2] == 1) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/rectangle";
              break;
          }
        }

        // B<W
        if (size_array[2] == 2) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/oval";
              break;
          }
        }
      }

      // B<H
      if (size_array[3] == 2) {
        // B>W
        if (size_array[2] == 0) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/hourglass";
              break;
          }
        }

        // B=W
        if (size_array[2] == 1) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }

        // B<W
        if (size_array[2] == 2) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }
      }
    }

    if (size_array[0] == 2) {
      // B>H
      if (size_array[3] == 1) {
        // B>W
        if (size_array[2] == 0) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/oval";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/hourglass";
              break;
          }
        }

        // B=W
        if (size_array[2] == 1) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }

        // B<W
        if (size_array[2] == 2) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }
      }

      // B=H
      if (size_array[3] == 0) {
        // B>W
        if (size_array[2] == 0) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/hourglass";
              break;
          }
        }

        // B=W
        if (size_array[2] == 1) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }

        // B<W
        if (size_array[2] == 2) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }
      }

      // B<H
      if (size_array[3] == 2) {
        // B>W
        if (size_array[2] == 0) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }

        // B=W
        if (size_array[2] == 1) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }

        // B<W
        if (size_array[2] == 2) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/triangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }
      }
    }
    if (size_array[0] == 1) {
      // B>H
      if (size_array[3] == 1) {
        // B>W
        if (size_array[2] == 0) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/inverted-triangle";
              break;
          }
        }

        // B=W
        if (size_array[2] == 1) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/inverted-triangle";
              break;
          }
        }

        // B<W
        if (size_array[2] == 2) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/inverted-triangle";
              break;
          }
        }
      }

      // B=H
      if (size_array[3] == 0) {
        // B>W
        if (size_array[2] == 0) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/hourglass";
              break;
          }
        }

        // B=W
        if (size_array[2] == 1) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/rectangle";
              break;
          }
        }

        // B<W
        if (size_array[2] == 2) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/rectangle";
              break;
          }
        }
      }

      // B<H
      if (size_array[3] == 2) {
        // B>W
        if (size_array[2] == 0) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/hourglass";
              break;
          }
        }

        // B=W
        if (size_array[2] == 1) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/inverted-triangle";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/rectangle";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/hourglass";
              break;
          }
        }

        // B<W
        if (size_array[2] == 2) {
          switch (size_array[1]) {
              // W>H
            case '2':
              window.location.href = "/pages/oval";
              break;
              // W=H
            case '1':
              window.location.href = "/pages/oval";
              break;
              // W<H
            case '0':
              window.location.href = "/pages/triangle";
              break;
          }
        }
      }
    }
  }

  function next_slide(select){
    var next = $(select).attr("data-next");
    if(next == 'finished'){
      var data_result = $(select).find(".img").attr("data-item");
      var step_no = $(select).attr("data-step");
      size_array[step_no] = data_result;
      checkShoulderEqualHips();
    }
    else{
      all_step.hide();
      $("#"+next).show();
      var data_result = $(select).find(".img").attr("data-item");
      var step_no = $(select).attr("data-step");
      size_array[step_no] = data_result;
      progress_next();
    }
  }
  $("#calculate_shape .steps .imgs").click(function(){
    next_slide(this);
  });
  function img_blur(){
    $( ".img_blur" ).each(function() {
      var img = $(this);
      var orignal_size =  img.attr("data-img");
      img.attr("src",orignal_size);
      img.removeClass("img_blur_effect");
    });
  }
  img_blur();
  $("#collection_people .item").click(function(){

  });
  $(".spt-box-container .sp-fix a:contains('Fit & Sizing Chart')").addClass('fit-sizing');

  if($(".fit-sizing").length > 0){
    var href = $(".fit-sizing").attr('href');
    if(href != null || href != ''){
      href = href.replace("//igigi1.myshopify.com",""); 
      href = href.replace("http:","");
      href= href+"?view=nohtml";
    }
    $(".fit-sizing").click(function(e){
      e.preventDefault();
      $.get(href, function(data){
        var div = $('<div id="size-guide">');
        div.append(data);
        var inst = div.remodal();
        inst.open();  
      })
    });
  }
  $(".pt-filter-top .filter-group-color ul li .collection-name a").each(function(){
  var color = $(this).text().toLowerCase();
    $(this).find("i").css("background",color);
  });
});